import dayjs from "dayjs";
import * as zod from "zod";

export const paymentAndTransactionFormSchema = zod
  .object({
    startDate: zod.custom<dayjs.Dayjs>(
      (val) => dayjs.isDayjs(val) && val !== null,
      "Başlangıç tarihi zorunludur"
    ),
    endDate: zod.custom<dayjs.Dayjs>(
      (val) => dayjs.isDayjs(val) && val !== null,
      "Bitiş tarihi zorunludur"
    ),
    transactionType: zod.string(),
    orderId: zod.string(),
    cardNumber: zod.string(),
    authCode: zod.string(),
    status: zod.string(),
    bankCode: zod.string(),
    refundAmount: zod.string(),
    merchantId: zod.any(),
    filterMerchantId: zod.any(),
    originalPaymentModel: zod.any()
  })
  .refine(
    (data) => data.startDate.isValid(),
    {
      message: "Geçerli bir başlangıç tarihi giriniz",
      path: ["startDate"],
    }
  )
  .refine(
    (data) => data.endDate.isValid(),
    {
      message: "Geçerli bir bitiş tarihi giriniz",
      path: ["endDate"],
    }
  );

export type PaymentAndTransactionValuesType = zod.infer<
  typeof paymentAndTransactionFormSchema
>;

export const paymentAndTransactionInitialValues: PaymentAndTransactionValuesType =
{
  startDate: dayjs().subtract(1).startOf('day'),
  endDate: dayjs().endOf('day'),
  transactionType: "",
  orderId: "",
  cardNumber: "",
  authCode: "",
  status: "",
  bankCode: "",
  refundAmount: "",
  filterMerchantId: [],
  originalPaymentModel: ''
  // merchantId:0
};




export const merchantPaymentFormSchema = zod.object({

  startDate: zod.unknown().optional(),
  endDate: zod.unknown().optional(),
  startPaymentMerchantDate: zod.custom<dayjs.Dayjs>(
    (val) => dayjs.isDayjs(val) && val !== null,
    "Başlangıç tarihi zorunludur"
  ),
  endPaymentMerchantDate: zod.custom<dayjs.Dayjs>(
    (val) => dayjs.isDayjs(val) && val !== null,
    "Bitiş tarihi zorunludur"
  ),
  paymentFlag: zod.any().optional(),
  merchantId: zod.any().optional(),
  filterMerchantId: zod.any().optional()
})
  .refine(
    (data) => data.startPaymentMerchantDate.isValid(),
    {
      message: "Geçerli bir başlangıç tarihi giriniz",
      path: ["startPaymentMerchantDate"],
    }
  )
  .refine(
    (data) => data.endPaymentMerchantDate.isValid(),
    {
      message: "Geçerli bir bitiş tarihi giriniz",
      path: ["endPaymentMerchantDate"],
    }
  );

export type MerchantPaymentValuesType = zod.infer<
  typeof merchantPaymentFormSchema
>;

export const merchantPaymentInitialValues: MerchantPaymentValuesType =
{
  startPaymentMerchantDate: dayjs().subtract(1).startOf('day'),
  endPaymentMerchantDate: dayjs().endOf('day'),
  merchantId: 0,
  // endOfDate: null,
  paymentFlag: false
  // endDate: null,
  // transactionType: "",
  // orderId: "",
  // cardNumber: "",
  // authCode: "",
  // status: "",
  // bankCode: "",
  // refundAmount: "",
};





export const bankPaymentFormSchema = zod.object({
  date: zod.custom<dayjs.Dayjs>(
    (val) => dayjs.isDayjs(val) && val !== null,
    "Başlangıç tarihi zorunludur"
  ),
  bankCode: zod.any()
  // endDate: zod.any(),
  // transactionType: zod.string(),
  // orderId: zod.string(),
  // cardNumber: zod.string(),
  // authCode: zod.string(),
  // status: zod.string(),
  // bankCode: zod.string(),
  // refundAmount: zod.string(),
})
  .refine(
    (data) => data.date.isValid(),
    {
      message: "Geçerli bir tarih giriniz",
      path: ["date"],
    }
  );

export type BankPaymentValuesType = zod.infer<
  typeof bankPaymentFormSchema
>;

export const bankPaymentInitialValues: BankPaymentValuesType =
{
  bankCode: "",
  date: dayjs().startOf('day'),
};




export const paymentWithLinkedFormSchema = zod
  .object({
    bankCode: zod.string().optional(),
    orderId: zod
      .preprocess((val) => String(val).replace(/\s/g, '').trim(), zod.string()),
    merchantId: zod.number().positive(),
    amount: zod.string(),
    installmentCount: zod
      .string()
      .min(1, { message: "Taksit Sayısı seçiniz" }),
    description: zod
      .string()
      .min(1, { message: "Ürün adı giriniz." }),
    currency: zod
      .string()
      .min(1, { message: "Para birimi seçiniz." }),
    userEmail: zod
      .string()
      .trim()
      .regex(new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/), "")
      .optional()
      .or(zod.literal("")),
    userPhoneNumber: zod.preprocess(
      (val) =>
        String(val)
          .slice(1)
          .replaceAll("_", "")
          .replaceAll("(", "")
          .replaceAll(")", "")
          .replaceAll(" ", "")
          .trim(),
      zod.string().min(10).optional().or(zod.literal(""))
    ),
    startDate: zod.any(),
    endDate: zod.any(),
    url: zod.any(),
    lınkPaymentCount: zod.coerce.number().positive({ message: 'Değer pozitif bir tamsayı olmalıdır.' }),
    payerNote: zod.string().optional(),
    canPayerEditAmountOnLinkPayment: zod.boolean().optional(),
  }).refine((data) => {
    if (data.canPayerEditAmountOnLinkPayment) {
      return true;
    }
    return data.amount && parseFloat(data.amount.replace(",", ".")) > 0;
  }, {
    message: "Tutar 0'dan büyük olmalıdır.",
    path: ["amount"],
  });

export type PaymentWithLinkedValuesType = zod.infer<
  typeof paymentWithLinkedFormSchema
>;

export const paymentWithLinkedInitialValues: PaymentWithLinkedValuesType = {
  bankCode: "",
  orderId: "",
  merchantId: 0,
  amount: "",
  installmentCount: "",
  description: "",
  currency: "",
  userEmail: undefined,
  userPhoneNumber: "",
  startDate: null,
  endDate: null,
  url: undefined,
  lınkPaymentCount: 1,
  payerNote: "",
  canPayerEditAmountOnLinkPayment: false,
};

export const paymentWithLinkedListFormSchema = zod.object({
  merchantID: zod.number(),
  status: zod.string(),
});

export type PaymentWithLinkedListValuesType = zod.infer<
  typeof paymentWithLinkedListFormSchema
>;

export const paymentWithLinkedListInitialValues: PaymentWithLinkedListValuesType =
{
  merchantID: 0,
  status: "",
};



export const manualEntryPaymentFormSchema = zod.object({
  startPaymentMerchantDate: zod.unknown().optional(),
  endPaymentMerchantDate: zod.unknown().optional(),
  startDate: zod.custom<dayjs.Dayjs>(
    (val) => dayjs.isDayjs(val) && val !== null,
    "Başlangıç tarihi zorunludur"
  ),
  endDate: zod.custom<dayjs.Dayjs>(
    (val) => dayjs.isDayjs(val) && val !== null,
    "Bitiş tarihi zorunludur"
  ),
  paymentFlag: zod.any().optional(),
  merchantId: zod.any().optional()
})
  .refine(
    (data) => data.startDate.isValid(),
    {
      message: "Geçerli bir başlangıç tarihi giriniz",
      path: ["startDate"],
    }
  )
  .refine(
    (data) => data.endDate.isValid(),
    {
      message: "Geçerli bir bitiş tarihi giriniz",
      path: ["endDate"],
    }
  );

export type ManualEntryPaymentValuesType = zod.infer<
  typeof manualEntryPaymentFormSchema
>;

export const manualEntryPaymentInitialValues: ManualEntryPaymentValuesType = {
  merchantId: 0,
  startDate: dayjs().subtract(1).startOf('day'),
  endDate: dayjs().endOf('day'),
  // endOfDate: null,
  // endDate: null,
  // transactionType: "",
  // orderId: "",
  // cardNumber: "",
  // authCode: "",
  // status: "",
  // bankCode: "",
  // refundAmount: "",
};


export const merchantTotalTransactionFormSchema = zod.object({
  startDate: zod.custom<dayjs.Dayjs>(
    (val) => dayjs.isDayjs(val) && val !== null,
    "Başlangıç tarihi zorunludur"
  ),
  endDate: zod.custom<dayjs.Dayjs>(
    (val) => dayjs.isDayjs(val) && val !== null,
    "Bitiş tarihi zorunludur"
  ),
})
  .refine(
    (data) => data.startDate.isValid(),
    {
      message: "Geçerli bir başlangıç tarihi giriniz",
      path: ["startDate"],
    }
  )
  .refine(
    (data) => data.endDate.isValid(),
    {
      message: "Geçerli bir bitiş tarihi giriniz",
      path: ["endDate"],
    }
  );

export type MerchantTotalTransactionValuesType = zod.infer<
  typeof merchantTotalTransactionFormSchema
>;

export const merchantTotalTransactionInitialValues: MerchantTotalTransactionValuesType =
{
  startDate: dayjs().subtract(1).startOf('day'),
  endDate: dayjs().endOf('day'),
};

export const getDailyBankAccountHistoryFormSchema = zod.object({
  month: zod.any(),
  year: zod.any()
});

export type DailyBankAccountHistoryValuesType = zod.infer<
  typeof getDailyBankAccountHistoryFormSchema
>;

export const dailyBankAccountHistoryInitialValues: DailyBankAccountHistoryValuesType =
{
  month: null,
  year: null
};